import { useEffect, useRef } from "react";
import { useMatch } from "react-router-dom";
import * as Path from "../Routes/paths";

const ZENDESK_API_KEY = process.env.REACT_APP_ZENDESK_API_KEY;

export const useZendeskChat = () => {
  const zendeskRef = useRef(null);
  const zendeskScriptLoaded = useRef(false);
  const isMobilePath = useMatch(Path.mobileTodoReports);

  useEffect(() => {
    if (zendeskScriptLoaded.current || isMobilePath) {
      return;
    }

    const scriptTag = document.createElement("script");
    scriptTag.id = "ze-snippet";
    scriptTag.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_API_KEY}`;

    if (zendeskRef.current) {
      zendeskRef.current.appendChild(scriptTag);
      zendeskScriptLoaded.current = true;
    }
  }, [isMobilePath]);

  return zendeskRef;
};
